import React from "react";
import { VStack } from "@design-system/VStack/VStack";
import { ConnectPlaid } from "../plaid/ConnectPlaid/ConnectPlaid";
import { useEntity } from "../entity/useEntity";
import { AddAccount } from "./AddAccount";

export const EntityNoAccounts: React.FC = () => {
    const entity = useEntity();

    return (
        <VStack
            align="center"
            className="text-center no-accounts"
            data-testid="entity-no-accounts"
        >
            {!entity.isMockEntity ? (
                <p>
                    Add your {entity.isPersonal ? "personal" : "business"}{" "}
                    accounts to max out your tax savings.
                </p>
            ) : (
                <p>
                    Well done! All business accounts associated with entities in
                    Kick.
                </p>
            )}

            {!entity.isMockEntity && entity.isPersonal && (
                <ConnectPlaid
                    btnVariant="primary"
                    btnText="Add account"
                    defaultEntity={entity}
                />
            )}
            {!entity.isMockEntity && !entity.isPersonal && (
                <AddAccount
                    btnText="Add account"
                    btnVariant="primary"
                    defaultEntity={entity}
                />
            )}
        </VStack>
    );
};
